import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

export const ContainerDiv = styled.div`
  background-color: ${Styles.Themes.UnipolColors.blueSeven};
  color: ${Styles.Themes.UnipolColors.white};
  ${Styles.PageColorUtils.pageColorThemeOnly(
    (themeColor: any) => `
    background-color: ${themeColor.mainColor};
    color: ${themeColor.invertedMainColor};
  `
  )}

  padding-top: ${(props) => props["data-margin-top"]};
  padding-bottom: ${(props) => props["data-margin-bottom"]};
  font-family: "Unipol";
  width: 100%;
  overflow: visible;
  position: relative;
  overflow: hidden;

  box-sizing: border-box;

  .content-wrapper {
    margin: 0 auto;
    max-width: 1280px;
    width: auto;
    box-sizing: border-box;

    &.horizontal-margin-aggiornamento-profilo {
      margin: 0 10%;
      ${Styles.BreakpointsUtils.mobileOnly(`
        margin: 0;
      `)}

      >.text-container {
        margin: 0;
        padding-right: 0;
        padding-left: 0;
      }

      ${Styles.BreakpointsUtils.mobileOnly(`
        >.text-container{
         padding-right: 16px;
         padding-left: 16px;
        }
      `)}
    }
  }

  .rich-text-container {
    overflow: hidden;
  }

  .rich-text-preview-mode-container {
    p {
      margin-bottom: 10px;
    }
  }
  .text-container {
    margin-left: 8.33333333%;
    width: 91.66666667%;
    min-height: 140px;
    position: relative;
    padding: 50px 4px 0 4px;
    box-sizing: border-box;
    &.tpd_no_margin {
      padding-top: 0;
    }
    a {
      color: #fff;
      text-decoration: none;
    }

    ${Styles.LayoutUtils.pageLayout1ColumnOnly(`
      ${Styles.BreakpointsUtils.tabletOnly(`
        margin-left: calc(100%*3/24);
        max-width: 75.2%;
      `)}
    `)}

    &.margin {
      .title,
      .paragraph {
        ${Styles.LayoutUtils.pageLayout1ColumnOnly(`
        margin-top: 20px;
        margin-bottom: 10px;
      `)}
      }
    }
  }

  .title {
    padding: 10px 0;
    box-sizing: border-box;
    font-size: 40px;
    font-family: Unipol Bold;
    line-height: 48px;
    margin: 0;
    h1 {
      font-size: 40px;
      font-family: Unipol Bold;
      line-height: 48px;
      margin: 0;
    }
  }

  .paragraph {
    padding: 20px 0 40px;
    font-size: 24px;
    line-height: 29px;
    box-sizing: border-box;
    h2 {
      font-size: 24px;
      line-height: 29px;
      margin-right: 25px;
      margin-bottom: 10px;
    }

    b {
      span {
        font-family: Unipol Bold !important;
      }
    }
  }

  ${Styles.BreakpointsUtils.mobileOnly(`
    .content-wrapper {
      max-width: 767px;
      width: auto;
    }
    .text-container {
      padding-top: 40px;
      margin-left: 0;
      width: 100%;
      &.tpd_no_margin {
        padding-top: 0;
      }
    }
    .title {
      font-size: 30px;
      line-height: 37px;
      h1 {
        font-size: 30px;
        line-height: 37px;
      }
    }
    .paragraph {
      margin-right: 0;
    }
  `)};

  ${Styles.BreakpointsUtils.tabletOnly(`
    .content-wrapper {
      max-width: 1279px;
      width: auto;
    }
    .text-container {
      margin-left: 4.16666667%;
      padding: 60px 4px 0 4px;
      width: 91.66666667%;
      &.tpd_no_margin {
        padding-top: 0;
      }
    }
  `)};
`;
